import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { TexasSwitch } from '@texas/components/shared/form/TexasSwitch';
import {
  articleJobActionStyles,
  articleJobSidebarActionStyles,
} from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';

interface Props {
  variant?: 'card' | 'sidebar';
  title: string;
  description: string;
  buttonLabel: string;
  ignoreClashes: boolean;
  showIgnoreClashes?: boolean;
  ignoredCount: number;
  onIgnoreChange: (value: boolean) => void;
  canSubmit: boolean;
  loading: boolean;
  onSubmit: () => void;
}

export function ArticleJobAction(props: Props) {
  const { t } = useTranslation();
  const styles =
    props.variant === 'sidebar'
      ? articleJobSidebarActionStyles
      : articleJobActionStyles;
  return (
    <Box sx={styles.card}>
      <Heading sx={styles.title}>{props.title}</Heading>
      <Text sx={styles.description}>{props.description}</Text>
      {props.showIgnoreClashes !== false && (
        <Box sx={styles.options}>
          <TexasSwitch
            checked={props.ignoreClashes}
            label={t('article.copy.ignoreClashingItemCodes')}
            labelColor="inherit"
            onChange={props.onIgnoreChange}
          />
          {props.ignoreClashes && props.ignoredCount > 0 && (
            <Text sx={styles.ignored}>
              {t('article.copy.ignoredClashingItemCodes', {
                count: props.ignoredCount,
              })}
            </Text>
          )}
        </Box>
      )}
      <Button
        sx={styles.submit}
        isDisabled={!props.canSubmit}
        isLoading={props.loading}
        onClick={props.onSubmit}
        variant="texas-solid"
      >
        {props.buttonLabel}
      </Button>
    </Box>
  );
}
